import React, { Component } from 'react';
import { ButtonGroup, Button, Radio, Modal } from 'react-bootstrap';

class PrintButton extends Component {
  state: {
    selected: number,
    show_modal: boolean
  };

  constructor() {
    super();
    this.state = {
      selected: 1,
      show_modal: false
    }
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  handleOptionChange(changeEvent) {
    this.setState({selected: parseInt(changeEvent.target.value, 10)});
  }

  open() {
    this.setState({show_modal: true});
  }

  close() {
    this.setState({show_modal: false});
  }

  print(printFn) {
    printFn(this.state.selected);
    this.close();
  }

  render(props) {
    var option_list = {
      "1": "Puzzle with blank diagram",
      "2": "Solution with clues",
      "4": "Solution without clues"
    };
    var options = [];
    for (var i in option_list) {
      if (!option_list.hasOwnProperty(i))
        continue;

      options.push(<Radio name="print" key={i} value={i}
        checked={this.state.selected == i}
        onChange={(x) => this.handleOptionChange(x)}>{option_list[i]}</Radio>);
    }

    return (
      <ButtonGroup>
      <Button className={"xwordjs-print-button"} title="Print" bsSize="xsmall" onClick={this.open}>
        <img src={"images/print.gif"}/>
      </Button>
      <Modal show={this.state.show_modal} onHide={this.close} bsSize="small">
        <Modal.Header closeButton>
          <Modal.Title>Print</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="xwordjs-print-menu">
            What would you like to print?
            {options}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.print(this.props.onSelect)}>Print</Button>
        </Modal.Footer>
      </Modal>
      </ButtonGroup>);
  }
}

export default PrintButton;



// WEBPACK FOOTER //
// ./src/PrintButton.js